import React, { useEffect, useState } from "react";

export default function Countdown({ targetIso, className = "" }) {
  const [diff, setDiff] = useState(() => Math.max(0, new Date(targetIso).getTime() - Date.now()));

  useEffect(() => {
    const t = setInterval(() => {
      setDiff(Math.max(0, new Date(targetIso).getTime() - Date.now()));
    }, 1000);
    return () => clearInterval(t);
  }, [targetIso]);

  const s = Math.floor(diff / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;

  const blocks = [
    { v: d, l: "days" },
    { v: h, l: "hrs" },
    { v: m, l: "min" },
    { v: sec, l: "sec" },
  ];

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="countdown">
      {blocks.map((b, i) => (
        <div key={i} className="glass-strong rounded-xl px-3 py-2 min-w-[58px] text-center">
          <div className="font-mono text-lg sm:text-xl font-semibold tabular-nums">{String(b.v).padStart(2, "0")}</div>
          <div className="text-[10px] uppercase tracking-wider text-[var(--text-mute)]">{b.l}</div>
        </div>
      ))}
    </div>
  );
}
